import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DISCOUNT_CODE: "Rabattkode",
      GIFTCARD_CODE: "Gavekort",
      NAME: "Navn",
      DISCOUNT: "Rabatt",
      APPLIES: "Gjelder",
      DELIVERY: "levering",
      DELIVERIES: "leveringer",
      EXPIRES: "Utløper",
      AMOUNT: "Beløp",
      REMAINING_AMOUNT: "Gjenstående beløp",
      ACTIVE: "aktiv",
      UPCOMING: "kommende",
      EXPIRED: "utløpt",
      USED: "Brukt",
      CREDIT: "Kreditt",
      REFERENCE: "Ref.",
      REMAINING_CREDIT: "Utestående kreditt",
      PERMANENT: "Permanent",
      CUSTOMER_SERVICE: "Kundeservice",
      GIFTCARD: "Gavekort",
      CUSTOMER_CLUB: "Kundeklubb",
    },
    se: {
      DISCOUNT_CODE: "Rabattkod",
      GIFTCARD_CODE: "Presentkort",
      NAME: "Namn",
      DISCOUNT: "Rabatt",
      APPLIES: "Gäller",
      DELIVERY: "leverans",
      DELIVERIES: "leveranser",
      EXPIRES: "Utgår",
      USED: "Använd",
      AMOUNT: "Belopp",
      REMAINING_AMOUNT: "Återstående belopp",
      ACTIVE: "aktiv",
      UPCOMING: "kommande",
      EXPIRED: "förfallen",
      CREDIT: "Krediter",
      REFERENCE: "Ref.",
      REMAINING_CREDIT: "Innestående kredit",
      PERMANENT: "Permanent",
      CUSTOMER_SERVICE: "Kundtjänst",
      GIFTCARD: "Presentkort",
      CUSTOMER_CLUB: "Kundklubb",
    },
    dk: {
      DISCOUNT_CODE: "Rabatkode",
      GIFTCARD_CODE: "Gavekort",
      NAME: "Navn",
      DISCOUNT: "Rabat",
      APPLIES: "Gælder",
      DELIVERY: "leveringer",
      DELIVERIES: "leveringer",
      EXPIRES: "Udløber",
      USED: "Brugt",
      AMOUNT: "Beløb",
      REMAINING_AMOUNT: "Resterende beløb",
      ACTIVE: "aktiv",
      UPCOMING: "kommende",
      EXPIRED: "udløbet",
      CREDIT: "Kredit",
      REFERENCE: "Ref.",
      REMAINING_CREDIT: "Udestående kredit",
      PERMANENT: "Permanent",
      CUSTOMER_SERVICE: "Kundeservice",
      GIFTCARD: "Gavekort",
      CUSTOMER_CLUB: "Kundeklub",
    },
  } as const
)[language];
